import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import axios from 'axios'; 
import { API_URL } from '../../constant';
import ReCAPTCHA from "react-google-recaptcha";


const ContactForm = (props) => {
    const [forms, setForms] = useState({
        name: '',
        email: '',
        subject: '',
        phone: '',
        company: '',
        message: ''
    });
    
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));
    
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

    const [captchaToken, setCaptchaToken] = useState(null); // recaptcha


    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    // captcha handler
    const onCaptchaChange = (token) => {
        setCaptchaToken(token);
    };


    const submitHandler = async (e) => {
        e.preventDefault();

        // Check reCAPTCHA
        if (!captchaToken) {
            setSubmitStatus({
                type: 'error',
                message: 'Please verify that you are not a robot.'
            });
            return;
        }
        
        if (validator.allValid()) {
            validator.hideMessages();
            setIsSubmitting(true);
            setSubmitStatus({ type: '', message: '' });
            
            try {
                // Call Laravel API endpoint
                const response = await axios.post(`${API_URL}/api/contact`, {
                    ...forms,
                    recaptcha_token: captchaToken, // ADD THIS
                    to_email: 'info@topcoinuk.com' 
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                });
                
                if (response.data.success) {
                    setSubmitStatus({
                        type: 'success',
                        message: 'Message sent successfully to info@topcoinuk.com!'
                    });
                    
                    // Reset form
                    setForms({
                        name: '',
                        email: '',
                        subject: '',
                        phone: '',
                        company: '',
                        message: ''
                    });

                    setCaptchaToken(null); // reset captcha
                }
                
            } catch (error) {
                console.error('Error sending message:', error);
                
                let errorMessage = 'Failed to send message. Please try again.';
                
                if (error.response) {
                    // Server responded with error status
                    if (error.response.data.errors) {
                        // Laravel validation errors
                        const errors = error.response.data.errors;
                        errorMessage = Object.values(errors)[0][0];
                    } else if (error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                }
                
                setSubmitStatus({
                    type: 'error',
                    message: errorMessage
                });
            } finally {
                setIsSubmitting(false);
                
                // Clear status message after 5 seconds
                setTimeout(() => {
                    setSubmitStatus({ type: '', message: '' });
                }, 5000);
            }
        } else {
            validator.showMessages();
        }
            setIsSubmitting(true);
            setSubmitStatus({ type: '', message: '' });
            
            try {
                // Call Laravel API endpoint
                const response = await axios.post(`${API_URL}/api/contact`, {
                    ...forms,
                    recaptcha_token: captchaToken, // ADD THIS
                    to_email: 'info@topcoinuk.com' 
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                });
                
                if (response.data.success) {
                    setSubmitStatus({
                        type: 'success',
                        message: 'Message sent successfully to info@topcoinuk.com!'
                    });
                    
                    // Reset form
                    setForms({
                        name: '',
                        email: '',
                        subject: '',
                        phone: '',
                        company: '',
                        message: ''
                    });

                    setCaptchaToken(null); // reset captcha
                }
                
            } catch (error) {
                console.error('Error sending message:', error);
                
                let errorMessage = 'Failed to send message. Please try again.';
                
                if (error.response) {
                    // Server responded with error status
                    if (error.response.data.errors) {
                        // Laravel validation errors
                        const errors = error.response.data.errors;
                        errorMessage = Object.values(errors)[0][0];
                    } else if (error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                }
                
                setSubmitStatus({
                    type: 'error',
                    message: errorMessage
                });
            } finally {
                setIsSubmitting(false);
                
                // Clear status message after 5 seconds
                setTimeout(() => {
                    setSubmitStatus({ type: '', message: '' });
                }, 5000);
            }
        // } else {
        //     validator.showMessages();
        // }
    };

    return (
        <>
            {submitStatus.type === 'success' && (
                <div className="alert alert-success" style={{ marginBottom: '30px', marginTop: '-20px' }}>
                    <i className="fa-solid fa-circle-check"></i> {submitStatus.message}
                </div>
            )}
            
            {submitStatus.type === 'error' && (
                <div className="alert alert-danger" style={{ marginBottom: '30px',marginTop: '-20px' }}>
                    <i className="fa-solid fa-circle-exclamation"></i> {submitStatus.message}
                </div>
            )}
            
            {/* <form onSubmit={submitHandler}> */}
            <form onSubmit={submitHandler}>
                <div className="row mx-4 mx-md-0">   
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="input_title" htmlFor="input_name">Name<sup>*</sup></label>
                            <div className="input-box">
                                <input
                                    value={forms.name}
                                    type="text"
                                    name="name"
                                    className="form-control"
                                    placeholder="Carlo Castillo"
                                    onBlur={(e) => changeHandler(e)}
                                    onChange={(e) => changeHandler(e)} />
                                {validator.message('name', forms.name, 'required|alpha_space|max:255')}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="input_title" htmlFor="input_email">Email<sup>*</sup></label>
                            <input
                                value={forms.email}
                                type="email"
                                name="email"
                                className="form-control"
                                placeholder="alma.lawson@example.com"
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)} />
                            {validator.message('email', forms.email, 'required|email|max:255')}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="input_title" htmlFor="input_subject">Subject<sup>*</sup></label>
                            <input
                                value={forms.subject}
                                type="text"
                                name="subject"
                                className="form-control"
                                placeholder="Subject"
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)} />
                            {validator.message('subject', forms.subject, 'required|max:255')}
                        </div>
                    </div> 
                    {/* <div className="col-md-6">
                        <div className="form-group">
                            <label className="input_title" htmlFor="input_company">Company</label>
                            <input
                                value={forms.company}
                                type="text"
                                name="company"
                                className="form-control"
                                placeholder="Company Name"
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)} />
                        </div>
                    </div> */}
                    <div className="col-12">
                        <div className="form-group">
                            <label className="input_title" htmlFor="input_phone">Phone</label>
                            <div className="input-box">
                                <input
                                    value={forms.phone}
                                    type="tel"
                                    name="phone"
                                    className="form-control"
                                    placeholder="(+44) 1680-6361-89"
                                    onBlur={(e) => changeHandler(e)}
                                    onChange={(e) => changeHandler(e)} />
                                {validator.message('phone', forms.phone, 'phone|max:20')}
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <label className="input_title" htmlFor="input_message">Your inquiry<sup>*</sup></label>
                            <textarea
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                                value={forms.message}
                                name="message"
                                className="form-control"
                                placeholder="Write about your self..."
                                rows="6">
                            </textarea>
                            {validator.message('message', forms.message, 'required|max:1000')}
                        </div>

                        <div style={{ marginBottom: "16px", display: "flex", alignItems: "center", flexDirection: "column" }}>
                            <ReCAPTCHA
                                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                onChange={onCaptchaChange}
                            />
                        </div>


                        <button 
                            // className="btn" 
                            // type="submit"
                            // disabled={isSubmitting || !captchaToken}
                            type="submit"
                            className="btn"
                            disabled={isSubmitting}
                        >
                            <span className="btn_label">
                                {isSubmitting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                        Sending...
                                    </>
                                ) : 'Submit'}
                            </span>
                            <span className="btn_icon">
                                <i className="fa-solid fa-arrow-up-right"></i>
                            </span>
                        </button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default ContactForm;